import { useMemo } from "react";
import { getAuthErrorQueryParam } from "../../../utils/domainUtils";
import { ErrorType } from "../../../enums";
import { isEmptyString } from "../../../utils/commonUtils";

// TODO [LOWA-30534] From: https://tiny.amazon.com/1gsgtp0es
export const useCheckAuthErrorAlertOnInitStep = () => {
    return useMemo(() => {
        const authErrorQueryParam = getAuthErrorQueryParam();
        return (
            authErrorQueryParam.errorCode === ErrorType.UNAUTHORIZED &&
            isEmptyString(authErrorQueryParam.errorDescription)
        );
    }, []);
};
